import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { menuCategories } from '@/config/menuConfig';

const AccordionMenu = () => {
  const location = useLocation();
  const [openCategories, setOpenCategories] = useState<string[]>([]);

  // Auto-expand current category on mount and route change
  useEffect(() => {
    const currentPath = location.pathname;
    const currentCategory = menuCategories.find((category) =>
      category.items.some((item) => currentPath.startsWith(item.path))
    );

    if (currentCategory) {
      setOpenCategories((prev) =>
        prev.includes(currentCategory.id) ? prev : [...prev, currentCategory.id]
      );
    }
  }, [location.pathname]);

  const toggleCategory = (categoryId: string) => {
    setOpenCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <nav>
      {menuCategories.map((category) => {
        const isOpen = openCategories.includes(category.id);

        return (
          <div key={category.id} className="mb-2">
            {/* Category Header */}
            <button
              onClick={() => toggleCategory(category.id)}
              className="w-full px-6 py-3 flex items-center justify-between hover:bg-admin-sidebarHover transition-colors"
            >
              <div className="flex items-center">
                <span className="mr-3 text-lg">{category.icon}</span>
                <span className="font-medium">{category.title}</span>
              </div>
              <svg
                className={`w-4 h-4 transition-transform ${
                  isOpen ? 'transform rotate-180' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            {/* Category Items */}
            {isOpen && (
              <div className="bg-admin-sidebar">
                {category.items.map((item) => (
                  <Link
                    key={item.id}
                    to={item.path}
                    className={`block px-6 py-2 pl-14 text-sm hover:bg-admin-sidebarHover transition-colors ${
                      isActive(item.path)
                        ? 'bg-admin-sidebarHover text-white font-medium border-l-4 border-admin-accent'
                        : 'text-gray-300'
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default AccordionMenu;
